import { assessmentEngine } from "@/lib/assessments/assessmentEngineSingleton";
import { useLocalStorageStore, useStore } from "@/store";
import { FlowHelpers } from "./flowTypeHelpers";

export const resetState = () => {
	const flow = useStore.getState().flow;
	useLocalStorageStore.getState().resetPriceInfo();
	useLocalStorageStore.getState().setFunctionalTestsUpdatedTimestamp(null);
	assessmentEngine.ResetFunctionalAssessments();
	assessmentEngine.ResetSelfAssessments();
	if (!FlowHelpers.isCosmeticFirst(flow)) assessmentEngine.ResetGraderAssessments();
	const assessmentEngineState = assessmentEngine.ExportState();
	useLocalStorageStore.getState().setAssessmentEngineState(assessmentEngineState);
};
